module.exports = __webpack_public_path__ + "img/circulo_celeste_oi_64px.63a6dad5.png";